import { computed, defineComponent, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useSmartBack } from '@/composables/use-smart-back'
import {
  NavBar as VanNavBar,
  Icon as VanIcon,
  Search as VanSearch,
  Sticky as VanSticky,
  PullRefresh as VanPullRefresh,
  List as VanList,
  Empty as VanEmpty,
  Row as VanRow,
  Col as VanCol,
  showToast,
} from 'vant'
import { getApiV1CommunityList, postApiV1UserFollow } from '@/api/sdk.gen'
import { mapApiPost, type ForumPost } from '@/stores/forum-store'
import { useAuthStore } from '@/stores/auth-store'
import { useFollowStore } from '@/stores/follow-store'
import {
  ForumUserImg,
  renderPostStats,
  renderPostSummary,
  renderPostTitle,
} from '@/components/forum-post-parts'

// 对应 49208 /serachassistant?type=3 论坛搜索（chunk-48ccddc6）
// 根 class .search-wrap，卡片样式继承全局 .forum-list（与 forum 主页同款）
export default defineComponent({
  name: 'ForumSearchPage',
  setup() {
    const route = useRoute()
    const router = useRouter()
  const goBack = useSmartBack()
    const authStore = useAuthStore()
    const followStore = useFollowStore()

    const navTitle = computed(() => String(route.query.webtitle || '论坛搜索'))
    const value = ref('')
    const list = ref<ForumPost[]>([])
    const page = ref(0)
    const loading = ref(false)
    const finished = ref(false)
    const refreshing = ref(false)

    async function fetchList(reset = false) {
      const kw = value.value.trim()
      if (!kw) {
        list.value = []
        finished.value = true
        loading.value = false
        return
      }
      if (reset) {
        page.value = 0
        list.value = []
        finished.value = false
      }
      page.value += 1
      try {
        const res = await getApiV1CommunityList({
          query: { page: page.value, size: 20, keyword: kw },
        })
        const items = (res.data?.data?.list ?? []).map(mapApiPost)
        list.value = [...list.value, ...items]
        if (items.length < 20) finished.value = true
      } finally {
        loading.value = false
      }
    }

    function onSearch() {
      fetchList(true)
    }

    async function onRefresh() {
      await fetchList(true)
      refreshing.value = false
    }

    function go(p: ForumPost) {
      router.push(`/forum/detail/${p.postId}`)
    }

    async function onToggleConcern(p: ForumPost) {
      if (!authStore.isLoggedIn) {
        router.push('/login')
        return
      }
      const uid = Number(p.userId)
      if (!uid) return
      const prev = followStore.isFollowing(uid)
      followStore.setFollowed(uid, !prev)
      try {
        await postApiV1UserFollow({ body: { follow_user_id: uid } })
      } catch {
        followStore.setFollowed(uid, prev)
        showToast('操作失败')
      }
    }

    return () => (
      <div class="search-wrap">
        <VanSticky>
          <VanNavBar title={navTitle.value} onClickLeft={() => goBack()}>
            {{ left: () => <VanIcon name="arrow-left" color="#333" size="16" /> }}
          </VanNavBar>
        </VanSticky>

        <div class="search-hd">
          <VanSearch
            v-model={value.value}
            placeholder="请输入您想要的内容"
            shape="round"
            background="#fff"
            show-action
            onSearch={onSearch}
          >
            {{
              action: () => (
                <button type="button" class="search-btn btn-reset" onClick={onSearch}>
                  搜索
                </button>
              ),
            }}
          </VanSearch>
        </div>

        <div class="forum-body-bd">
        <VanPullRefresh
          modelValue={refreshing.value}
          onUpdate:modelValue={(v: boolean) => (refreshing.value = v)}
          onRefresh={onRefresh}
        >
          <VanList
            loading={loading.value}
            onUpdate:loading={(v: boolean) => (loading.value = v)}
            finished={finished.value}
            finishedText=""
            immediateCheck={false}
            onLoad={() => fetchList(false)}
          >
            {list.value.length === 0 ? (
              <VanEmpty description="输入标题或作者关键词以查找" />
            ) : (
              <ul class="forum-list">
                {list.value.map((post) => {
                  const concerned = followStore.isFollowing(post.userId)
                  return (
                    <li key={post.postId}>
                      <div class="user-info-box">
                        <ForumUserImg post={post} />
                      </div>

                      <div class="forumflow">
                        <button type="button" class="btn-reset" onClick={() => onToggleConcern(post)}>
                          {concerned ? '已关注' : '+ 关注'}
                        </button>
                      </div>

                      <VanRow class="title" onClick={() => go(post)}>
                        <VanCol class="slabel">{post.periodStr}</VanCol>
                        <VanCol span={21}>
                          <div class="van19 van-ellipsis">
                            {renderPostTitle(post)}
                            {post.read && <div class="reads">已读</div>}
                          </div>
                        </VanCol>
                      </VanRow>

                      {renderPostSummary(post)}

                      {renderPostStats(post)}
                    </li>
                  )
                })}
              </ul>
            )}
          </VanList>
        </VanPullRefresh>
        </div>
      </div>
    )
  },
})
